<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickable" @click="msgAlerta=null">{{ msgAlerta }}</div>

    <div class="proc-view-page">
        <section v-if="objView" class="proc-header">
            <div>
                <div class="proc-title">{{ objView.nmprocesso }}</div>
                <div class="proc-subtitle">
                    Protocolo {{ objView.protocolo }} • {{ formatDate(objView.dtprocesso) }} {{ objView.hrprocesso || '' }}
                </div>
            </div>


            <div class="proc-header-actions">
                <div class="proc-status" :class="statusClass(objView.nmstatus)">
                    {{ objView.nmstatus }}
                </div>

                <button class="btn-small" @click="closeForm">
                    Voltar
                </button>
            </div>


            <div class="proc-info-grid">
                <div class="proc-info-item">
                    <span>SIM</span>
                    <strong>{{ objView.nmsim || '-' }}</strong>
                </div>

                <div class="proc-info-item">
                    <span>Estabelecimento</span>
                    <strong>{{ objView.nmestabelecimento || '-' }}</strong>
                </div>

                <div class="proc-info-item">
                    <span>CPF/CNPJ</span>
                    <strong>{{ objView.cpfcnpj || '-' }}</strong>
                </div>

                <div class="proc-info-item">
                    <span>Nº SIM</span>
                    <strong>{{ objView.nrosim || '-' }}</strong>
                </div>

                <div class="proc-info-item">
                    <span>Etapa atual</span>
                    <strong>{{ objView.nmetapa || '-' }}</strong>
                </div>

                <div class="proc-info-item">
                    <span>Status etapa</span>
                    <strong>{{ objView.nmstatus_etapa || '-' }}</strong>
                </div>
            </div>
        </section>


        <section v-if="lsTimeline.length" class="proc-timeline-panel">
            <div class="proc-timeline">
                <div
                    v-for="(tl, index) in lsTimeline"
                    :key="`${tl.idetapa || 'future'}-${tl.idepproc_etapa}-${index}`"
                    class="proc-timeline-item"
                    :class="timelineClass(tl)"
                    @click="selecionarEtapaPorTimeline(tl)"
                >
                    <div class="proc-timeline-line"></div>

                    <div class="proc-timeline-dot">
                        <span v-if="tl.ckatual === 'S'"></span>
                    </div>

                    <div class="proc-timeline-tooltip">
                        <strong>{{ tl.nmetapa }}</strong>

                        <div>Entrada: {{ formatDateTime(tl.dhentrada) }}</div>
                        <div>Usuário entrada: {{ tl.nmusuario_entrada || '-' }}</div>

                        <template v-if="tl.dhsaida">
                            <div>Saída: {{ formatDateTime(tl.dhsaida) }}</div>
                            <div>Usuário saída: {{ tl.nmusuario_saida || '-' }}</div>
                        </template>

                        <template v-else-if="tl.ckatual === 'S'">
                            <div class="tooltip-current">Etapa atual</div>
                        </template>

                        <template v-else>
                            <div class="tooltip-future">Etapa futura</div>
                        </template>
                    </div>
                </div>
            </div>
        </section>


        <section class="proc-layout">
            <aside class="proc-etapas">
                <div
                    v-for="etapa in lsEtapas"
                    :key="etapa.id"
                    class="proc-etapa-card"
                    :class="{ active: etapaSelecionada?.id === etapa.id }"
                    @click="selecionarEtapa(etapa)"
                >
                    <div class="proc-etapa-line">
                        <div class="proc-etapa-order">{{ etapa.ordem }}</div>

                        <div class="proc-etapa-main">
                            <div class="proc-etapa-title">{{ etapa.nmetapa }}</div>
                            <div class="proc-etapa-date">
                                Entrada: {{ formatDateTime(etapa.dhentrada) }}
                            </div>
                            <div v-if="etapa.dhsaida" class="proc-etapa-date">
                                Saída: {{ formatDateTime(etapa.dhsaida) }}
                            </div>
                        </div>
                    </div>

                    <div class="proc-etapa-footer">
                        <span class="proc-chip" :class="statusClass(etapa.nmstatus)">
                            {{ etapa.nmstatus }}
                        </span>

                        <span class="proc-mini-info">
                            {{ anexosDaEtapa(etapa.id).length }} anexo(s)
                        </span>
                    </div>
                </div>
            </aside>

            <main class="proc-detalhes">
                <template v-if="etapaSelecionada">
                    <div class="proc-detail-header">
                        <div>
                            <div class="proc-section-title">{{ etapaSelecionada.nmetapa }}</div>
                            <div class="proc-detail-subtitle">
                                {{ formatDateTime(etapaSelecionada.dhentrada) }}
                                <template v-if="etapaSelecionada.dhsaida">
                                    até {{ formatDateTime(etapaSelecionada.dhsaida) }}
                                </template>
                            </div>
                        </div>

                        <span class="proc-chip" :class="statusClass(etapaSelecionada.nmstatus)">
                            {{ etapaSelecionada.nmstatus }}
                        </span>
                    </div>

                    <div v-if="etapaSelecionada.retornada_justificativa" class="info-alert row-space">
                        <span class="text">{{ etapaSelecionada.retornada_justificativa }}</span>
                    </div>

                    <div v-if="anexosSelecionados.length" class="proc-anexos-list">
                        <div
                            v-for="anexo in anexosSelecionados"
                            :key="`${anexo.id}-${anexo.idproc_etapa_inclusao || 'ppt-null'}`"
                            class="proc-anexo-card"
                            :class="{ removed: !!anexo.removido_dh }"
                        >
                            <div class="proc-anexo-main">
                                <div class="proc-anexo-icon">
                                    {{ anexo.idanexo ? '📎' : '📄' }}
                                </div>

                                <div class="proc-anexo-content">
                                    <div class="proc-anexo-title">{{ anexo.nmitem }}</div>

                                    <div class="proc-anexo-meta">
                                        <span v-if="anexo.nmreferencia">{{ anexo.nmreferencia }}</span>
                                        <span v-if="anexo.dhavaliacao">
                                            Analisado em {{ formatDateTime(anexo.dhavaliacao) }}
                                        </span>
                                        <span v-if="anexo.removido_dh">
                                            Removido em {{ formatDateTime(anexo.removido_dh) }}
                                        </span>
                                    </div>

                                    <div v-if="anexo.justificativa" class="proc-anexo-obs">
                                        {{ anexo.justificativa }}
                                    </div>
                                </div>
                            </div>

                            <div class="proc-anexo-actions">
                                <span class="proc-chip" :class="statusClass(anexo.nmstatus)">
                                    {{ anexo.nmstatus }}
                                </span>

                                <button
                                    v-if="anexo.idanexo || anexo.idlaudo"
                                    class="btn-small"
                                    @click.stop="abrirAnexo(anexo.idanexo ?? anexo.idlaudo)"
                                >
                                    Abrir
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-else class="info-empty">
                        Nenhum anexo/documento vinculado nesta etapa.
                    </div>
                </template>

                <div v-else class="info-empty">
                    Selecione uma etapa para visualizar os anexos.
                </div>
            </main>
        </section>
    </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const props = defineProps({ idProcesso: Number });

const isLoading = ref(false);
const lsEtapas = ref([]);
const lsAnexos = ref([]);
const lsTimeline = ref([]);
const msgAlerta = ref(null);
const objView = ref(null);
const etapaSelecionada = ref(null);

const closeForm = () => emit('close');

const lsEtapasOrdenadas = computed(() => {
    return [...(lsEtapas.value || [])].sort((a, b) => Number(a.ordem || 0) - Number(b.ordem || 0));
});

const anexosSelecionados = computed(() => {
    if (!etapaSelecionada.value) return [];
    return anexosDaEtapa(etapaSelecionada.value.id);
});

function anexosDaEtapa(idEtapa) {
    return (lsAnexos.value || []).filter(a => Number(a.idproc_etapa_inclusao) === Number(idEtapa));
}

function selecionarEtapa(etapa) {
    etapaSelecionada.value = etapa;
}

function selecionarEtapaInicial() {
    if (!lsEtapasOrdenadas.value.length) {
        etapaSelecionada.value = null;
        return;
    }

    const idEtapaAtual = Number(objView.value?.id_etapa_atual || 0);

    etapaSelecionada.value =
        lsEtapasOrdenadas.value.find(e => Number(e.id) === idEtapaAtual)
        || lsEtapasOrdenadas.value[0];
}

function formatDate(value) {
    if (!value) return '-';

    const [yyyy, mm, dd] = String(value).substring(0, 10).split('-');
    if (!yyyy || !mm || !dd) return value;

    return `${dd}/${mm}/${yyyy}`;
}

function formatDateTime(value) {
    if (!value) return '-';

    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return value;

    return dt.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
}

function statusClass(status) {
    const s = String(status || '').toUpperCase();

    if (['FINALIZADO', 'HOMOLOGADO', 'APROVADO'].includes(s)) return 'ok';
    if (['REPROVADO', 'CANCELADO', 'REMOVIDO'].includes(s)) return 'bad';
    if (['ATIVO', 'EM ANDAMENTO', 'À CONFERIR', 'A CONFERIR'].includes(s)) return 'warn';

    return 'default';
}

async function abrirAnexo(idAnexo) {
    
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/operacoes/solicitar/download', { id: idAnexo });

        if (r.bolok === 1) {
            window.open(r.download_url, '_blank');
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const rProc = await Api.genericPost('/dados/proc', {
            idep: globalStore.idep,
            id: props.idProcesso,
        });
        objView.value = rProc?.[0] || null;

        const rEtapas = await Api.genericPost('/dados/proc/etapa', {
            idep: globalStore.idep,
            idreferencia: props.idProcesso,
        });
        lsEtapas.value = rEtapas || [];

        const rAnexos = await Api.genericPost('/dados/proc/anexos', {
            idep: globalStore.idep,
            idreferencia: props.idProcesso,
        });
        lsAnexos.value = rAnexos || [];

        const rTimeLine = await Api.genericPost('/dados/proc/timeline', {
            idep: globalStore.idep,
            idreferencia: props.idProcesso,
        });
        lsTimeline.value = rTimeLine || [];

        selecionarEtapaInicial();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

function timelineClass(tl) {
    if (tl.ckatual === 'S') return 'current';
    if (tl.ckaguardando === 'S') return 'future';
    if (tl.dhsaida) return 'done';

    return 'default';
}

function selecionarEtapaPorTimeline(tl) {
    if (!tl.idetapa) return;

    const etapa = lsEtapas.value.find(e => Number(e.id) === Number(tl.idetapa));
    if (etapa) etapaSelecionada.value = etapa;
}

watch(() => props.idProcesso, lerDados);

onMounted(lerDados);
</script>


<style scoped>
.proc-view-page {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.proc-toolbar {
    display: flex;
    justify-content: flex-start;
}

.proc-header {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px;
}

.proc-header-actions {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.proc-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #263f3d;
}

.proc-subtitle {
    margin-top: 3px;
    font-size: 0.9rem;
    color: #64748b;
}

.proc-info-grid {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: repeat(3, minmax(160px, 1fr));
    gap: 8px;
}

.proc-info-item {
    border: 1px solid #d7e3e2;
    border-radius: 6px;
    background: #f8fafc;
    padding: 6px 8px;
}

.proc-info-item span {
    display: block;
    font-size: 0.75rem;
    color: #64748b;
}

.proc-info-item strong {
    display: block;
    margin-top: 2px;
    color: #334155;
}

.proc-layout {
    display: grid;
    grid-template-columns: 340px 1fr;
    gap: 10px;
    align-items: start;
}

.proc-etapas,
.proc-detalhes {
    border: 2px solid #aaa;
    border-radius: 8px;
    background: #fff;
    padding: 10px;
}

.proc-etapas {
    max-height: calc(100vh - 220px);
    overflow-y: auto;
}

.proc-section-title {
    font-size: 1rem;
    font-weight: 700;
    color: #25413e;
    margin-bottom: 8px;
}

.proc-etapa-card {
    border: 1px solid #d7e3e2;
    border-radius: 8px;
    padding: 8px;
    background: #f8fafc;
    cursor: pointer;
    margin-bottom: 8px;
    transition: border-color .15s ease, background-color .15s ease;
}

.proc-etapa-card:hover {
    background: #eef7f6;
    border-color: #9bbfbb;
}

.proc-etapa-card.active {
    background: #dff0ee;
    border-color: #25413e;
    box-shadow: 0 0 0 1px #25413e inset;
}

.proc-etapa-line {
    display: flex;
    gap: 8px;
}

.proc-etapa-order {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #25413e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    flex: 0 0 28px;
}

.proc-etapa-main {
    min-width: 0;
    flex: 1;
    text-align: left;
}

.proc-etapa-title {
    font-weight: 700;
    color: #334155;
    line-height: 1.2;
}

.proc-etapa-date,
.proc-detail-subtitle,
.proc-anexo-meta {
    font-size: 0.8rem;
    color: #64748b;
}

.proc-etapa-footer {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
}

.proc-mini-info {
    font-size: 0.78rem;
    color: #475569;
}

.proc-detail-header {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 10px;
    text-align: left;
}

.proc-anexos-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.proc-anexo-card {
    border: 1px solid #d7e3e2;
    border-radius: 8px;
    padding: 8px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.proc-anexo-card.removed {
    opacity: .65;
    background: #f8fafc;
}

.proc-anexo-main {
    display: flex;
    gap: 8px;
    min-width: 0;
}

.proc-anexo-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    border-radius: 8px;
    background: #eef7f6;
    display: flex;
    align-items: center;
    justify-content: center;
}

.proc-anexo-content {
    min-width: 0;
    text-align: left;
}

.proc-anexo-title {
    font-weight: 700;
    color: #334155;
}

.proc-anexo-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 3px;
}

.proc-anexo-obs {
    margin-top: 6px;
    padding: 6px;
    border-radius: 5px;
    background: #fff8e1;
    color: #8a4b00;
    font-size: .85rem;
}

.proc-anexo-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.proc-chip,
.proc-status {
    border-radius: 999px;
    padding: 3px 8px;
    font-size: .75rem;
    font-weight: 700;
    white-space: nowrap;
    border: 1px solid transparent;
}

.proc-status {
    align-self: start;
}

.proc-chip.ok,
.proc-status.ok {
    background: #dcfce7;
    color: #166534;
    border-color: #86efac;
}

.proc-chip.bad,
.proc-status.bad {
    background: #fee2e2;
    color: #991b1b;
    border-color: #fca5a5;
}

.proc-chip.warn,
.proc-status.warn {
    background: #fff7ed;
    color: #9a3412;
    border-color: #fdba74;
}

.proc-chip.default,
.proc-status.default {
    background: #e2e8f0;
    color: #334155;
    border-color: #cbd5e1;
}

@media (max-width: 900px) {
    .proc-layout {
        grid-template-columns: 1fr;
    }

    .proc-etapas {
        max-height: none;
    }

    .proc-info-grid {
        grid-template-columns: 1fr;
    }

    .proc-anexo-card {
        flex-direction: column;
    }

    .proc-anexo-actions {
        justify-content: flex-end;
    }
}




.proc-timeline-panel {
    border: 2px solid #aaa;
    border-radius: 8px;
    background: #fff;
    padding: 8px 14px;
    overflow: visible;
}

.proc-timeline {
    display: flex;
    align-items: center;
    position: relative;
    overflow: visible;
    padding: 10px 4px;
}

.proc-timeline-item {
    position: relative;
    flex: 1 1 auto;
    min-width: 44px;
    height: 18px;
    text-align: center;
    cursor: default;
}

.proc-timeline-item.done,
.proc-timeline-item.current {
    cursor: pointer;
}

.proc-timeline-line {
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
    height: 2px;
    background: #cbd5e1;
    z-index: 1;
}

.proc-timeline-item:first-child .proc-timeline-line {
    left: 50%;
}

.proc-timeline-item:last-child .proc-timeline-line {
    right: 50%;
}

.proc-timeline-dot {
    position: relative;
    z-index: 2;
    width: 14px;
    height: 14px;
    margin: 2px auto 0;
    border-radius: 50%;
    border: 2px solid #cbd5e1;
    background: #f1f5f9;
}

.proc-timeline-item.done .proc-timeline-line,
.proc-timeline-item.done .proc-timeline-dot {
    background: #dcfce7;
    border-color: #22c55e;
}

.proc-timeline-item.current .proc-timeline-line,
.proc-timeline-item.current .proc-timeline-dot {
    background: #fff7ed;
    border-color: #f97316;
}

.proc-timeline-item.current .proc-timeline-dot {
    width: 18px;
    height: 18px;
    margin-top: 0;
    box-shadow: 0 0 0 4px rgba(249, 115, 22, .18);
}

.proc-timeline-item.future .proc-timeline-dot {
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.proc-timeline-tooltip {
    display: none;
    position: absolute;
    left: 50%;
    bottom: 26px;
    transform: translateX(-50%);
    z-index: 9999;
    width: 360px;
    padding: 8px;
    border-radius: 8px;
    background: #1e293b;
    color: #fff;
    text-align: left;
    font-size: .78rem;
    box-shadow: 0 8px 20px rgba(0,0,0,.22);
}

.proc-timeline-tooltip::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -6px;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #1e293b;
}

.proc-timeline-tooltip strong {
    display: block;
    margin-bottom: 5px;
}

.proc-timeline-item:hover .proc-timeline-tooltip {
    display: block;
}

.tooltip-current {
    margin-top: 5px;
    color: #fdba74;
    font-weight: 700;
}

.tooltip-future {
    margin-top: 5px;
    color: #cbd5e1;
    font-weight: 700;
}
</style>